import { Link } from 'react-router-dom'

import { Card, CardBody, PageHead, StateBlock } from '../components/ui.tsx'
import { usePageTitle } from '../layout/AppShell.tsx'

/**
 * A route in the canonical sitemap that this build has not implemented yet.
 *
 * It says so plainly. The alternative — a nav link that 404s, or worse, a screen that
 * renders convincing-looking blanks — is exactly the thing a trading surface must never
 * do.
 */
export function NotBuilt({
  title,
  design,
  publicPage,
}: {
  title: string
  design: string
  /** Public pages are already inside `PublicShell`'s <main>, so they must not open another. */
  publicPage?: boolean
}) {
  return publicPage ? (
    <NotBuiltBody title={title} design={design} />
  ) : (
    <AppNotBuilt title={title} design={design} />
  )
}

function AppNotBuilt({ title, design }: { title: string; design: string }) {
  usePageTitle(title)
  return (
    <main className="content">
      <PageHead title={title} />
      <NotBuiltBody title={title} design={design} />
    </main>
  )
}

function NotBuiltBody({ title, design }: { title: string; design: string }) {
  return (
    <Card>
      <CardBody>
        <StateBlock
          icon="◷"
          title={`${title} is not built yet`}
          text={
            <>
              This screen is in the sitemap and fully designed, but this build implements the six core screens
              first — Home, Positions, Market detail, Decision log, Risk centre and Place Bet — plus
              sign-in, sign-up and password recovery.
              <br />
              <br />
              The design for it lives at{' '}
              <span className="mono u-sm">docs/design/design-spec/pages/{design}</span>.
            </>
          }
          action={
            <Link className="btn outline" to="/">
              Back to Today
            </Link>
          }
        />
      </CardBody>
    </Card>
  )
}
